var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolskiP(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Polski_-_ikona",
    "data-name": "Polski - ikona",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1784",
    "data-name": "Rectangle 1784",
    width: 80,
    height: 80,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4966",
    "data-name": "Group 4966",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3698",
    "data-name": "Path 3698",
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0",
    fill: "#464af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3699",
    "data-name": "Path 3699",
    d: "M24.317,27.193a20.2,20.2,0,0,0-5.131-.642c-5.533.209-9.309,4.476-9.467,4.658l1.431,1.244c.033-.038,3.384-3.827,8.107-4a18.978,18.978,0,0,1,4.662.6c3.7.8,7.524,1.613,11.482-3.031l-1.447-1.231c-3.22,3.78-6.053,3.173-9.638,2.407",
    transform: "translate(11.879 30.294)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3700",
    "data-name": "Path 3700",
    d: "M48.123,7.429c-10.576,0-17.216,3.993-22.316,7.9l-.2.151-2.111,4.9L21.93,18.909l-.642.778A38.037,38.037,0,0,0,13.01,42.313,49.533,49.533,0,0,0,8.192,52.969l1.816.547a47.151,47.151,0,0,1,4.538-10.04c2.936-.109,16.413-1.2,25.664-12.06l.7-.827-3.122-2.02,6.507-3.1.022-.576c.18-4.787,1.7-10.053,4.658-16.1l.667-1.364Zm-5.676,16.82-8.542,4.069L38.045,31c-7.62,8.291-18.153,10.093-22.3,10.484A97.2,97.2,0,0,1,32.868,21.865l-1.216-1.456A97.717,97.717,0,0,0,15.2,38.829a36.318,36.318,0,0,1,6.922-17.144l2.056,1.927,2.982-6.924C31.728,13.211,37.6,9.711,46.61,9.356a41.543,41.543,0,0,0-4.162,14.893",
    transform: "translate(10.012 9.08)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolskiP);
export default __webpack_public_path__ + "static/media/polski-p.80d35c2d519c1fbd0285a8126fa2d1e6.svg";
export { ForwardRef as ReactComponent };